// extracted by mini-css-extract-plugin
module.exports = {"settingDrawerStyleHandler":"index_settingDrawerStyleHandler__2fZCe","title":"index_title__23I12","themeColor":"index_themeColor__3kdll"};